import { DialogContent, type DialogContentProps } from "@mui/material";

export function Body({ children, sx, ...rest }: DialogContentProps) {
	return (
		<DialogContent
			sx={{
				display: "flex",
				flexDirection: "column",
				maxHeight: "calc(70dvh - 80px)",
				gap: 2,
				boxSizing: "border-box",
				scrollbarGutter: "stable",
				...sx,
			}}
			{...rest}
		>
			{children}
		</DialogContent>
	);
}
